import React from 'react';
import Button from 'react-bootstrap/Button';
import { buildHierarchy, getAllImages } from "../../util";
import "./styles.css";
const AutoQAButton = ({
  panels,
  setShowReport
}) => {
  return /*#__PURE__*/React.createElement(Button, {
    className: "QA-button",
    onClick: () => {
      if (panels) {
        setShowReport(true);
      }
    }
  }, "QA");
};
export default AutoQAButton;